export function resolveFlowTenantId(
  sourceKey?: string,
  tenantId?: string,
): string {
  return sourceKey?.trim() || tenantId?.trim() || 'default';
}
